// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + {"636":"landing","696":"promo","753":"project-preview","967":"protocol"}[chunkId] + "." + {"636":"45a0c4bd","696":"6e82f558","753":"74354642","967":"e5a3c5f1"}[chunkId] + ".js";
};